import { createFormErrorMapper, ZodIssueMap } from '@/common/form/utils.ts';
import { useFieldContext } from '@/lib/form.ts';
import Box from '@mui/material/Box';
import { useStore } from '@tanstack/react-form';
import { uniq } from 'es-toolkit';

export interface FormFieldErrorsProps {
  zodIssueMap?: ZodIssueMap;
}

export const FormFieldErrors = ({ zodIssueMap }: FormFieldErrorsProps) => {
  const field = useFieldContext();
  const errors = useStore(field.store, (state) => state.meta.errors);

  const mapFormError = createFormErrorMapper(zodIssueMap ?? {});

  return uniq(errors.map(mapFormError)).map((err, idx) => (
    <Box key={idx} data-testid={`${field.name}-error`} component="span" sx={{ display: 'block' }}>
      {err}
    </Box>
  ));
};
